"use client";

import React from "react";
import { motion } from "motion/react";
import { cn } from "utils";
import CheckBox from "../CheckBox";
// import { useIsPc } from '../../hooks/useIsPc';
import { CheckBoxGroupProps } from "./types";
// 注释：引入类型定义，支持选择验证功能

export const CheckBoxGroup: React.FC<CheckBoxGroupProps> = ({
  options = [],
  value = [],
  onChange,
  validateSelectionChange,
  className = "",
  labelClassName = "",
}) => {
  //   const [isPc] = useIsPc();

  const handleCheckboxChange = (changedValue: string) => {
    const isSelected = value.includes(changedValue);
    const newValue = isSelected
      ? value.filter((v) => v !== changedValue)
      : [...value, changedValue];

    // 选择验证：如果提供了validateSelectionChange函数并且返回false，则不执行onChange
    if (
      validateSelectionChange &&
      !validateSelectionChange(changedValue, newValue)
    ) {
      return; // 验证不通过，不触发onChange
    }

    // 提供当前变化的值和所有选中值列表
    onChange?.(changedValue, newValue);
  };

  return (
    <div className={cn("flex flex-wrap gap-4", className)}>
      {options.map((option) => (
        <motion.div
          key={option.value}
          //   whileHover={{ scale: isPc ? 1.05 : 1 }}
          //   whileTap={{ scale: 0.95 }}
        >
          <div
            data-openreplay-label="misc_checkboxgroup_click"
            className="flex items-center gap-1 cursor-pointer"
            onClick={() =>
              !option.disabled && handleCheckboxChange(option.value)
            }
          >
            <CheckBox
              checked={value.includes(option.value)}
              classNames={cn(
                "w-3 h-3 rounded-[2px]",
                option.disabled && "opacity-50 cursor-not-allowed",
              )}
              iconSize={12}
            />
            <span
              className={cn(
                "body_medium_s text-content_primary",
                option.disabled ? "opacity-50" : "",
                labelClassName,
              )}
            >
              {option.label}
            </span>
          </div>
        </motion.div>
      ))}
    </div>
  );
};
